export const errorMessages = {
  failedVerificationCheckingAccount:
    "The account that you selected is not a checking account. Please try again. If necessary, connect to another institution.",
  failedVerificationSavingsAccount:
    "The account that you selected is not a savings account. Please try again. If necessary, connect to another institution.",
  strangerAccount:
    "The selected account is already associated with another Cache user. Please select a different account to continue.",
};
